import React from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  // convertStraight,
  convertThenFormat,
  formatDateTime,
} from "../../common-data/Converts";
import LeadLogsValue from "../fully-customised/LeadLogsValue";

const ConvertedLeads = ({ allDatas, isPage, setIsPage }) => {
  const { leadValuesConvertedLoading } = useSelector((state) => state.api);

  const tbColumns = [
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "Customer Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            ₹{convertThenFormat(row?.price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "lead_added_on",
      text: "lead added on",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.lead_added_on ? formatDateTime(row.lead_added_on) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
        {leadValuesConvertedLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allLeads}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {leadValuesConvertedLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <LeadLogsValue
            tableData={allDatas.allLeads}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default ConvertedLeads;
